@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div *ngIf="organization" class="organization container-fluid p-3 mb-5">
        <div class="w-fit">
            <app-back-button url="/organizations" component="Organizations"></app-back-button>
        </div>
        <div class="mt-3 d-flex justify-content-between align-items-center" id="organization-header-row">
            <h1>{{ organization.name }}</h1>
            <div class="d-flex mt-2 me-1">
                <button mat-raised-button *ngIf="tabIndex === 0 && !embeddedOrganizationBoolean" class="action-button d-flex col-auto align-items-center" (click)="basicInfo.onEditBasicInfoClick()">
                    <mat-icon class="button-icon">edit</mat-icon>
                    Edit Basic Info
                </button>
                <button mat-raised-button *ngIf="tabIndex === 1 && !embeddedOrganizationBoolean" class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="address.onEditAddressClick()">
                    <mat-icon class="button-icon">edit</mat-icon>
                    Edit Address
                </button>
                <button mat-raised-button *ngIf="organization.for_reservation && tabIndex === 3" class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onAssignPolicyClick()">
                    <mat-icon class="button-icon">add</mat-icon>
                    Assign Policy
                </button>
                <button mat-raised-button *ngIf="organization.for_guest_verification && tabIndex === 4 || !organization.for_reservation && tabIndex === 3" class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onAssignVerificationPackageClick()">
                    <mat-icon class="button-icon">add</mat-icon>
                    Assign
                </button>
                <ng-container *ngIf="deactivateOrganization && organizationIsActiveOrInactive">
                    <button mat-raised-button class="warn-button" style="margin-left:8px;" (click)="onUpdateOrganizationStatusClick()">
                        <mat-icon class="button-icon">delete</mat-icon>
                        Deactivate Organization
                    </button>
                </ng-container>
                <ng-container *ngIf="!deactivateOrganization && organizationIsActiveOrInactive && !embeddedOrganizationBoolean">
                    <button mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onUpdateOrganizationStatusClick()">
                        <mat-icon class="button-icon">check_box</mat-icon>
                        Activate Organization
                    </button>
                </ng-container>
                <ng-container *ngIf="!organizationIsActiveOrInactive">
                    <button mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onStartActivationProcessClick()">
                        <mat-icon class="button-icon">flight_takeoff</mat-icon>
                        Start Activation Process
                    </button>
                </ng-container>
            </div>
        </div>
        <mat-card class="my-5">
            <mat-tab-group animationDuration="0ms" dynamicHeight mat-align-tabs="center" class="pt-2" (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedIndex">
                <mat-tab label="Basic Info">
                    <app-org-basic-info [org]="organization" [embeddedOrganizationBoolean]="embeddedOrganizationBoolean" (organizationUpdatedEvent)="onOrganizationUpdated()" #basicInfo></app-org-basic-info>
                </mat-tab>
                <mat-tab label="Address">
                    <app-org-address [org]="organization" [embeddedOrganizationBoolean]="embeddedOrganizationBoolean" [states]="states" #address></app-org-address>
                </mat-tab>
                <ng-container *ngIf="!embeddedOrganizationBoolean">
                    <mat-tab label="Members">
                        <app-org-members [org]="organization" (organizationUpdated)="onOrganizationMemberDetailUpdate()"></app-org-members>
                    </mat-tab>
                    <mat-tab label="Assigned Policies" *ngIf="organization.for_reservation">
                        <app-org-assigned-policies 
                            #assignedPolicies 
                            [org]="organization"
                            (loadParent)="loadPage(organizationId)"
                        >
                        </app-org-assigned-policies>
                    </mat-tab>
                    <mat-tab label="Screening Packages" *ngIf="organization.for_guest_verification">
                        <app-org-verification-packages 
                            #verificationPackages 
                            [org]="organization"
                            (loadParent)="loadPage(organizationId)"
                        >
                        </app-org-verification-packages>
                    </mat-tab>
                </ng-container>
            </mat-tab-group>
        </mat-card>
    </div>
}